"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* How a log row reads in its table. A row keeps its initials and result
 * apart from its values, so a table's Initials and Result columns show
 * those, never values; the signed PDF stamps rows the same way
 * (forms_completion.go rowCellTexts). */
var _text = require('./text');


 const ROW_RESULT_LABELS = { given: 'Given', refused: 'Refused', missed: 'Missed' } ; exports.ROW_RESULT_LABELS = ROW_RESULT_LABELS

/* A column the family types into (text, time, date). */
 const isRowValueColumn = (column) => column.type !== 'result' && column.type !== 'initials'; exports.isRowValueColumn = isRowValueColumn

/* What a list row shows in each column, plus a last cell for the initials
 * when the table has no Initials column. Without a Result column the
 * initials carry it (R, M). */
 const rowCellTexts = (columns, row) => {
  const hasResult = columns.some(column => column.type === 'result')
  const mark = row.result === 'refused' ? ' R' : row.result === 'missed' ? ' M' : ''
  const initials = hasResult ? row.initials : row.initials + mark
  const cells = columns.map(column => {
    if (column.type === 'initials') return initials
    if (column.type === 'result') return row.result ? exports.ROW_RESULT_LABELS[row.result] : ''
    const value = _nullishCoalesce(row.values[column.id], () => ( ''))
    return column.type === 'date' ? _text.formDate.call(void 0, value) : value
  })
  return columns.some(column => column.type === 'initials') ? cells : [...cells, initials]
}; exports.rowCellTexts = rowCellTexts
